//
// ┌─────────────────────┐
// │ DO NOT EDIT BY HAND │
// └─────────────────────┘
//
// Generated by build.mjs in zinnia-icons
//
import { mapPropsToSvgProps, Props } from "../utils";
function IconMiscErrorHandler(iconProps: Props) {
  const props = mapPropsToSvgProps(iconProps);
  return <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path fill="currentColor" fillRule="evenodd" d="M8 2H2v6h6zM6 4H4v2h2zm3.5 0H22v9h-6v-2h4V6H9.5zM22 16h-6v6h6zm-7.5-1L9 12l5.5-3zm0 3h-2v2h2zM9 18h2v2H9zm-1.5 0h-2v2h2zM2 18h2v2H2zm2-3.5H2v2h2zM2 11h2v2H2zm5.5 0h-2v2h2z" clipRule="evenodd" /></svg>;
}
export default IconMiscErrorHandler;